/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InApp/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2DesktopChat from 'DesignSystem/Svgs/Tysiav2DesktopChat/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function InApp({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/Comms/Content/ContactMethods/Item/InApp",
  isSubmitting,
  isDisabled,
  disabled
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled})
let contactMethodsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'contact_methods',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting,
  isDisabled,
  disabled,
  isHovered
  
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<button
  data-testid="InApp.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={contactMethodsIsSubmittingData}
 style={{'--mr-1-56Jpv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-2-56Jpv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-3-56Jpv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-56Jpv': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-56Jpv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-6-56Jpv': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-7-56Jpv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-8-56Jpv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-9-56Jpv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-10-56Jpv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-11-56Jpv': isHovered ? dtColorsNeutral200 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2DesktopChat
  viewPath={`${viewPath}/Tysiav2DesktopChat`}
 width={14}
 height={14}
 stroke={dtColorsNeutral700}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Secure message"
 cursor="pointer"
 size="xmedium"
 marginLeft={dtSpaceXs}
 color={disabled ? dtColorsNeutral400 : dtColorsNeutral900}
/>
</button>
{children}
</React.Fragment>)
}